import api from "./client";
export async function getCategories() {
    const res = await api.get("/admin/cookies/categories");
    return res.data;
}
export async function upsertCategory(data) {
    const res = await api.post("/admin/cookies/categories", data);
    return res.data;
}
export async function updateCategory(id, data) {
    const res = await api.put(`/admin/cookies/categories/${id}`, data);
    return res.data;
}
export async function deleteCategory(id) {
    await api.delete(`/admin/cookies/categories/${id}`);
}
export async function createDefinition(data) {
    const res = await api.post("/admin/cookies/definitions", data);
    return res.data;
}
export async function updateDefinition(id, data) {
    const res = await api.put(`/admin/cookies/definitions/${id}`, data);
    return res.data;
}
export async function deleteDefinition(id) {
    await api.delete(`/admin/cookies/definitions/${id}`);
}
export async function getConsents(params) {
    const res = await api.get("/admin/cookies/consents", { params });
    return res.data;
}
